// eslint-disable-next-line import/no-unresolved
const axios = require('axios');

const intance = axios.create({
    baseURL: `https://gatekeeper-api.profabric.tech`
});

module.exports = intance;
